import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { IMAGE_DISCLAIMER } from "@/constants/content";

export const Lightbox = ({ images, index, onClose, onPrev, onNext }) => {
  if (index === null) return null;
  const item = images[index];
  return (
    <AnimatePresence>
      <motion.div
        className="cp-lightbox"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        data-testid="lightbox-overlay"
      >
        <button
          className="cp-lightbox-close"
          onClick={onClose}
          aria-label="Close"
          data-testid="lightbox-close-btn"
        >
          <X size={22} />
        </button>
        {images.length > 1 && (
          <>
            <button
              className="cp-lightbox-nav left"
              onClick={(e) => { e.stopPropagation(); onPrev(); }}
              aria-label="Previous image"
              data-testid="lightbox-prev-btn"
            >
              <ChevronLeft size={26} />
            </button>
            <button
              className="cp-lightbox-nav right"
              onClick={(e) => { e.stopPropagation(); onNext(); }}
              aria-label="Next image"
              data-testid="lightbox-next-btn"
            >
              <ChevronRight size={26} />
            </button>
          </>
        )}
        <motion.img
          key={item.src}
          src={item.src}
          alt={item.alt}
          initial={{ scale: 0.94, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="cp-lightbox-img"
          onClick={(e) => e.stopPropagation()}
          data-testid="lightbox-image"
        />
        {item.alt && <div className="cp-lightbox-caption">{item.alt}</div>}
        <p className="cp-lightbox-disclaimer">{IMAGE_DISCLAIMER}</p>
      </motion.div>
    </AnimatePresence>
  );
};
